module.exports = __webpack_public_path__ + "img/germany-blood-diseases-female.841e24f6.png";